// 🚀 AI 도메인 전용 클라이언트
// 완전 독립적인 AI API 클라이언트

// 생성된 AI API와 타입들을 export
// Orval이 생성한 AI 관련 React Query hooks와 API 함수들
export * from './client_gen_gen_generated/index.ts';

// 추가 타입 정의 (OpenAPI 스펙에서 누락된 타입들)
export enum ConversationMessageRequestRole {
  USER = 'USER',
  ASSISTANT = 'ASSISTANT',
  SYSTEM = 'SYSTEM'
}
